import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

function trackVoucherInfoClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'IconClick',
            label: 'Info_BuyVoucher',
        });
    }, 0);
}

function trackTicketInfoClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'IconClick',
            label: 'Info_BookAppointment',
        });
    }, 0);
}

function trackBuyVoucherClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'ButtonClick',
            label: 'BuyVoucher',
            eventData: {
                eventName: GA4EventName.SelectProductVariant,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                selected_value: 'Experience voucher',
            },
        });
    }, 0);
}

function trackBuyTicketClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'ButtonClick',
            label: 'BookAppointment',
            eventData: {
                eventName: GA4EventName.SelectProductVariant,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                selected_value: 'Experience ticket',
            },
        });
    }, 0);
}

export {
    trackBuyTicketClicked,
    trackBuyVoucherClicked,
    trackTicketInfoClicked,
    trackVoucherInfoClicked,
};
